export const routes = {
  HOME: '/',
  LOGIN: '/login',
  PESQUISA_SATISFACAO_CRIAR: '/pesquisa-satisfacao/criar',
  PESQUISA_SATISFACAO_PRINCIPAL: '/pesquisa-satisfacao/principal',
  APLICATIVOS_PRINCIPAL: '/aplicativos/principal',
};
